import styled from '@emotion/styled';
import UnstyledButton from '@expPlatform/embeds/embed/components/common/UnstyledButton';
export const SharePanelOptionContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const CopyButton = styled(UnstyledButton) `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
`;
export const SharePanelOptionLabel = styled.div `
  text-align: center;
  font-size: 0.9em;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: var(--spacing-1);
`;
export const SharePanelOption = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
